<div class="modal-header {{mType}}">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="btn-close" ngbAutofocus (click)="doAction('CLOSE', null)"></button>
</div>
<div class="modal-body" [innerHTML]="message">
    <p>
        <strong>Are you sure you want to delete <span class="text-primary">"John Doe"</span> profile?</strong>
    </p>
    <p>       
        All information associated to this user profile will be permanently deleted.
        <span class="text-danger">This operation can not be undone.</span>
    </p>
</div>
@if(buttons && buttons.length>0){
    <div class="modal-footer {{mType}}">
        @for (buttonObj of buttons; track $index; let i = $index) {
            <button type="button" class="{{buttonObj?.class}}" (click)="doAction(buttonObj?.eventType || 'BUTTON_ACTION', buttonObj)">{{buttonObj?.text}}</button>
        }       
    </div>
}
